/**
 * What the one IPMA managed flag on a meeting application is called.
 *
 * There is a single stored value behind it. A COD delegate or substitute holds
 * a seat that is invoiced, so for them it reads as the invoice; for a COD
 * observer, for every CSP application and for the IPMA attendance form the same
 * value simply says the application was verified. The API sends the name to use
 * per application in `flag`, so nothing here has to guess from the role.
 */
export const FLAG_INVOICE = 'INVOICE';
export const FLAG_VERIFIED = 'VERIFIED';

const KEYS = {
  [FLAG_INVOICE]: {
    column: 'page.ipma.meetings.list.invoice',
    on: 'page.ipma.meetings.list.invoicePaid',
    off: 'page.ipma.meetings.list.invoiceUnpaid',
    onLong: 'page.ma.meetings.list.invoicePaid',
    offLong: 'page.ma.meetings.list.invoiceUnpaid',
    filterOn: 'page.ipma.meetings.list.invoiceFilterPaid',
    filterOff: 'page.ipma.meetings.list.invoiceFilterUnpaid',
    placeholder: 'page.ipma.meetings.list.invoicePlaceholder',
  },
  [FLAG_VERIFIED]: {
    column: 'page.ipma.meetings.list.verified',
    on: 'page.ipma.meetings.list.verifiedOn',
    off: 'page.ipma.meetings.list.verifiedOff',
    onLong: 'page.ma.meetings.list.verifiedOn',
    offLong: 'page.ma.meetings.list.verifiedOff',
    filterOn: 'page.ipma.meetings.list.verifiedFilterOn',
    filterOff: 'page.ipma.meetings.list.verifiedFilterOff',
    placeholder: 'page.ipma.meetings.list.verifiedPlaceholder',
  },
};

/** The translation keys of one row, by the name the API gave it. */
export const flagKeys = (flag) => KEYS[flag] || KEYS[FLAG_INVOICE];

/**
 * The heading of the column, which belongs to the whole table rather than to
 * one row. It carries one name, never two: only a COD table can hold invoiced
 * seats, so it is the invoice there and the verified flag everywhere else.
 *
 * A COD table can still hold a verified row - an observer sitting between two
 * delegates - and that row says so itself.
 *
 * A table where the rows are known to agree - the purple one, which only ever
 * shows the applications of the reader themselves - passes that shared flag in
 * and gets its name back instead.
 */
export const flagColumnKeys = (meetingType, sharedFlag = null) => {
  if (sharedFlag) {
    return KEYS[sharedFlag] || KEYS[FLAG_INVOICE];
  }

  return meetingType === 'cod' ? KEYS[FLAG_INVOICE] : KEYS[FLAG_VERIFIED];
};

export default flagKeys;
